import { render, staticRenderFns } from "./Assing.vue?vue&type=template&id=b2970018"
import script from "./Assing.vue?vue&type=script&lang=js"
export * from "./Assing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports